import { render, staticRenderFns } from "./staticEr.vue?vue&type=template&id=68eab698&scoped=true&"
import script from "./staticEr.vue?vue&type=script&lang=js&"
export * from "./staticEr.vue?vue&type=script&lang=js&"
import style0 from "./staticEr.vue?vue&type=style&index=0&lang=css&"
import style1 from "./staticEr.vue?vue&type=style&index=1&id=68eab698&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68eab698",
  null
  
)

export default component.exports